import $ from 'jquery';
import async from 'async';
import apilayer from 'imports-loader?socketio=libwtgserver/socketio,toolbox=libwtgserver/toolbox,packetbuilder=libwtgserver/packetbuilder!libwtgserver/apilayer';
import toolbox from 'libwtgserver/toolbox';
import base64 from 'libwtgserver/base64';
import webrtc from '../webrtc';
import TODO from '../TODO';
import {speed_test} from 'speed-test/js/speedTest';
import xtransport from 'exports-loader?xtransport!novnc/include/xtransport';

angular.module('SupportAgent')
.factory(
 'EventHandler',
 ['$window','$rootScope','$location','$timeout',
  'U','L','INTERACT','INTRACTABLE','IDA','PERSISTENCE',
 function EventHandlerFactory($window, $rootScope, $location, $timeout,
  U,L,INTERACT,INTRACTABLE,IDA,PERSISTENCE ) {
  $rootScope.showLoginPage = function() {
   $rootScope.$evalAsync(function () {
    location.reload();
   });
  };
  C11N.root_path = "/";
  C11N.is_portal = true;
  var remoteCallback = {
   onSendData: function(data) {
    // Send data over X transport
    var d = new Array();
    for(var i=0; i<data.length; i++) d.push(data[i]);
    APILAYER.sendData($rootScope.remoteCID, d);
   },
   updateState: function(rfb, state, oldstate, msg) {
    var klass;
    switch(state) {
    case 'failed':
    case 'fatal':
     klass = "noVNC_status_error";
     break;
    case 'normal':
     klass = "noVNC_status_normal";
     break;
    case 'disconnected':
     // falls through
    case 'loaded':
     klass = "noVNC_status_normal";
     break;
    case 'password':
     klass = "noVNC_status_password";
     break;
    default:
     klass = "noVNC_status_warn";
     break;
    }
    if(rfb._fb_name != undefined)
     $D('noVNC_status').innerHTML = rfb._fb_name;
    //desktopGeometry
    if(rfb._rfb_port != undefined) $("#HostId").html(rfb._rfb_host + ':' + rfb._rfb_port);
    if(rfb._rfb_version != undefined) $("#protocolVersion").html(rfb._rfb_version);
    if(rfb._fb_width != undefined) $("#deviceWidth").html(rfb._fb_width);
    if(rfb._fb_height != undefined) $("#deviceHeight").html(rfb._fb_height);
    if(rfb._fb_depth != undefined) $("#pixelFormat").html(rfb._fb_depth + ' bpp');
    if(msg != undefined)
     $D('noVNC_status').innerHTML = msg;
    // Make use of klass to update UI
    L.trace({klass:klass,state:state},'VNC State - ' + klass + ' - ' + state);
    $('#noVNC_canvas').focusout(function() {
     rfb.get_keyboard().set_focused(false);
    }).focusin(function() {
     rfb.get_keyboard().set_focused(true);
    });
    $('#noVNC_canvas').click(function(/*event*/) {
     rfb.get_keyboard().set_focused(true);
    });
    $('#timeline').click(function(/*event*/) {
     rfb.get_keyboard().set_focused(false);
    });
   },
   // Disable/enable XVP button
   updateXvpVisualState: function(/*ver*/) {
    /* TODO: what the fuck is that?
    if (ver >= 1) {
     // show xvp
    }
    else {
     // hide xvp
    }
    */
   },
   clipReceive: function(/*rfb, text*/) {
    // process clipboard text
   },
   // Update the viewport drag/move button
   updateViewDrag: function(/*show, enable*/) {
   },
   // Display the desktop name in the document title
   updateDocumentTitle: function(/*rfb, name*/) {
   }
  };
  var novnc = new xtransport();
  var permEvent = {1: "onChatPermission", 2: "onRemPermission", 3: "onDiagPermission"};
  var msgEvent = {1: "onChatMessage", 2: "onRemMessage", 3: "onDiagMessage", 6: "onDiagResultMessage",10:"onWRTCConfigMessage"};
  var APILAYER = new apilayer().set_logger(L);
  var WTGTB = new toolbox();
  var BASE64 = new base64();
  var WRTC=new webrtc();
  var images = {};
  $rootScope.sessionExpired = false;
  $rootScope.sendButtonKeyEvent = function(id) {
   novnc.sendButtonKeyEvent(id);
  };

  $rootScope.$on('wtg.interact.login',function on_interact_login(evt,args) {
   var selfid = args.acid;
   L.trace({curacid:selfid},"Agent account id: "+selfid);
   WRTC.init(selfid,APILAYER,L,webRTCHandler);
   APILAYER.getGroups(); // TODO: should be in `INTERACT`
   window.setInterval(function(){ // TODO: should be elsewhere, not sure where, yet, though…
    if(!$rootScope.sessionExpired) {
     APILAYER.pingServer([1,2,3]);
     $rootScope.pingServerTimer = setTimeout(function(){
      clearTimeout($rootScope.pingServerTimer);
      $rootScope.sessionExpired = true;
      $('#session-expire-modal').modal();
     }, 55000);
    }
   }, 60000);
   INTRACTABLE.request("domain/assets",{},(e,r)=>{
    $rootScope.brand_color = r.color||$rootScope.brand_color||"#749935";
    $rootScope.brand_logo = r.logo_rect||$rootScope.default_brand_logo;
    $rootScope.notification_icon = r.logo_sqr||$rootScope.notification_icon;
    $rootScope.favicon_svg = r.logo_sqr||"";
   });
   INTRACTABLE.request("user/verify",{},(e,r)=>{
    if(e) return L.error({err:e},"error fetching user's access details");
    $rootScope.user_access=r;
   });
   INTRACTABLE.request("conversation/list", /* TODO: should be in interact */
    {pandomain:true, S:[INTERACT.D.conversation.status.ongoing,INTERACT.D.conversation.status.pending]},
    function(e, r) {
     if(e) return L.error({err:e},"error fetching conversations list");
     else if(r._S!='ok') return L.error({r:r},"error fetching conversations list");
     (r.conversations||[]).map(function(x) {
      x.ts=U.time.from_unix_epoch(x.ts);
      return x;
     }).forEach(function(c) {
      var cid = +c.display_name;
      var convo = INTERACT.get_conversation(cid)||INTERACT.add_conversation(cid);
      convo.update({status: c.status_id,ts:c.ts,title:c.title});
      c.p.forEach(function(p) {
       var pa = INTERACT.get_account(p.id)||INTERACT.add_account(p.id);
       pa.set_dn(p.name).update({
        fn: p.first_name, ln: p.last_name
       }).set_agentness(p.is_agent);
       convo.add_participant(pa);
      });
     });
     /* I hope this is a temporary */
     $rootScope.$broadcast('wtg.xxx.loaded-conversations');
    }
   );
   async.parallel([ /* TODO: should be in some test-related module */
    function (callback) {
     INTRACTABLE.request("test/tests",{},function(e,r) {
      if(e) return callback(e);
      if(r._S!='ok') return L.error({r:r},"failed to test/tests"),callback(new Error("failed to fetch tests"));
      $rootScope.tests = [] ;
      $rootScope.all_tests = r.tests;
      callback();
     });
    },
    function (callback) {
     INTRACTABLE.request("test/groups",{},function(e,r) {
      if(e) return callback(e);
      if(r._S!='ok') return L.error({r:r},"failed to test/groups"),callback(new Error("failed to fetch test groups"));
      $rootScope.testGroups = [] ;
      $rootScope.groups = r.groups;
      callback();
     });
    },
    function(callback){
     INTRACTABLE.request("test/evaluations",{},
      function(e, r) {
       var evaluations = [];
       var ename="";
       if((!e) && (r._S=='ok')) {
        if($rootScope.strings.evaluations) {
         evaluations = r.evaluations.map(function(x) {
          ename = $rootScope.getEvaluationName(x.rid);
          if(ename!="") x.s = ename;
          return x;
         });
        }
        else evaluations = r.evaluations;
       }
       $rootScope.evaluations = evaluations;
       callback(null, 'evaluations');
      });
    }],
    function (err, result) {
     if(err) L.error({err:err},err);
     L.trace({r:result},"big parallel result that doesn't contain any data, because it probably operates on a global state as usually and for no discernible reason we log this lack of any data");
     $rootScope.$applyAsync(function() {
      /* TODO: this is pretty expensive couple of nested loops, but currently
       * I have no idea how to fix it without reworking half the codebase */
      $rootScope.all_groups = ($rootScope.groups||[]/*TODO: is that possible?*/).filter(function(g) {
       return $rootScope.all_tests.some(function(t) { return t.group_id=g.group_id && t.visible==1 });
      });
     });
    });
  });

  var apilayer_callbacks = {
   connected: function () {
    $rootScope.$broadcast('wtg.interact.connected');
   },
   onLogin: function (status, accountID, sessionID, accountNameType, accountName,sessionKey) {
    var bc = {
     status: status[0],
     actype: accountNameType,
     acname: accountName
    };
    if(!bc.status) Object.assign(bc,{
     acid: WTGTB.bytes2Number(accountID),
     sid: sessionID,
     skey: sessionKey
    });
    $rootScope.$broadcast('wtg.interact.account.login',bc);
   },
   onDeviceRegister: function (deviceID, loginToken, dn,rcode,model,imei,displayName) {
    var bc = {
     devname: dn,
     model: model,
     imei: imei,
     display_name: displayName,
     rc: rcode[0],
     devid: WTGTB.bytes2Number(deviceID),
     token: loginToken
    };
    $rootScope.$broadcast('wtg.interact.device.register',bc);
   },
   onDeviceLogin: function (deviceID, loginToken,sessionID,sessionKey) {
    //PDU 27
    var bc = { status: +!loginToken }; // reconstructing data eaten by apilayer…
    if(!bc.status) Object.assign(bc,{
     devid: WTGTB.bytes2Number(deviceID),
     token: loginToken, sid: sessionID, skey: sessionKey,
     sk: sessionKey
    });
    $rootScope.$broadcast('wtg.interact.device.login',bc);
   },
   onCreateAccount: function (status, accountID, sessionID, accountNameType, accountName, sessionKey) {
    var bc = { status: status[0] };
    if(bc.status==INTERACT.D.create_account.status.ok) Object.assign(bc,{
     acid: WTGTB.bytes2Number(accountID),
     actype: accountNameType,
     acname: accountName,
     sid: WTGTB.bytes2Number(sessionID),
     skey: sessionKey
    });
    $rootScope.$broadcast('wtg.interact.account.create',bc);
   },
   onQueryPermissions: function (parray, pc, acid) {
    $rootScope.$broadcast(permEvent[pc], parray, acid);
   },
   onLANID: function (lanid) {
    if (lanid != "") {
     L.trace({lanid:lanid},"LanID - " + lanid);
     APILAYER.resolveLANID(lanid);
    }
    else L.warn("LanID not recieved");
   },
   onResolveLANID: function (lanid) {
    if (lanid != "") {
     L.trace({lanid:lanid},"Resolve LanID - " + lanid);
    }
    else L.warn("Resolve LanID not recieved");
   },
   onResolveLANIDOwner: function (lanid) {
    if (lanid != "") {
     L.trace({lanid:lanid},"Resolve LanID Owner - " + lanid);
    }
    else L.warn("Resolve LanID not recieved");
   },
   // TODO: note, that there's NO such callback in apilayer
   onGrantPermission: function (acid, permissionID) {
    // Support gets "GrantPermission" request from the customer
    APILAYER.allowPermission(permissionID, true);
   },
   onPermissionStatus: function (pid, statuscode, acid, userdata) {
    // Customer gets status of his "GrantPermission" request
    $rootScope.$broadcast("onPermissionStatus", pid, statuscode, acid, userdata);
   },
   onPermissionUpdated: function (/*acid, statuscode*/) {
    // Support gets status of the "GrantPermission" he has approved/declined
   },
   onCreateConversation: function (chid, statuscode, acid, conid) {
    if(acid) acid = WTGTB.bytes2Number(acid);
    if(conid) {
     conid = WTGTB.bytes2Number(conid);
     var bc = { convid: conid, status: statuscode[0], chid: chid };
     if(acid) bc.acid = acid;
     L.trace({bc:bc},"onCreateCoversation");
     $rootScope.$broadcast('wtg.interact.create-conversation',bc);
    }else {
     L.warn({acid:acid,chid:chid,statuscode:statuscode,conid:conid},"Conversation not created - account Id - " + acid);
    }
   },
   // TODO: this fine callback is commented both here and in apilayer, whatever it signifies
   onInvitation: function (/*conid, acid, displayName*/) {
    // Support has got invitation and already approved it
    // Now start messaging
    // if (displayName == "") return;
   },
   onMessage: function (conid, accid, displayName, message, mSec, chid, msgid,did) {
    // Support/Customer gets the message
    var bc = {
     convid: WTGTB.bytes2Number(conid),
     acid: WTGTB.bytes2Number(accid),
     display_name: displayName,
     devid: WTGTB.bytes2Number(did),
     channelid: chid,
     msgid: WTGTB.bytes2Number(msgid),
     msg: ((typeof message === 'string') && (chid ==1))?WTGTB.utf8Decode(message):message,
     ts: U.time.from_interact_epoch(mSec)
    };
    $rootScope.$broadcast('wtg.interact.conversation.message',bc);
    $rootScope.$broadcast('wtg.interact.conversation.message:'+bc.channelid,bc);
    $rootScope.$broadcast(msgEvent[chid],bc.convid,bc.acid,bc.display_name,
        bc.msg,bc.ts,bc.channelid,bc.msgid,bc.devid);
   },
   onDiagnosticResult: function(messageID,testID,eCode,mseconds,accountID,deviceID,tResult,tComment,sessionID,resData) {
    var acid = WTGTB.bytes2Number(accountID);
    // TODO: I doubt this filtering should happen here
    if($rootScope.accountID != acid) return;
    L.trace({tid:testID,tres:tResult,tc:tComment,ec:eCode,mid:messageID,rd:resData},"testID: "+testID +" testresult: "+tResult +" testcomment: "+tComment +" ecode:"+eCode+ "messageID"+messageID,
     "resultData:"+resData);
    var bc = { mid: WTGTB.bytes2Number(messageID),
               testid: WTGTB.bytes2Number(testID),
               evalcode: eCode,
               mseconds: mseconds, // TODO: WTF? Luckily, seems to be unused
               acid: acid,
             };
    if(deviceID) bc.devid = WTGTB.bytes2Number(deviceID);
    if(tResult) bc.result = tResult;
    if(tComment) bc.comment = tComment;
    if(sessionID) bc.sid = WTGTB.bytes2Number(sessionID);
    if(resData) bc.rdata = resData;
    $rootScope.$broadcast('wtg.interact.diag-result',bc);
   },
   onQueryPendingPermissionsSets: function (npermissionSets, lpermissionSets) {
    L.trace({nps:npermissionSets},"npermissionSets:" + npermissionSets);
    for (var i = 0; i < lpermissionSets.length; i++) {
     L.trace("permission id:" + lpermissionSets[i].di264.d);
     if(lpermissionSets[i].di258)
      L.trace("targetuser id:" + lpermissionSets[i].di258.d);
     else if (lpermissionSets[i].di259)
      L.trace("initiatinguser id:" + lpermissionSets[i].di259.d);
    }
   },
   onerror: function (err) { // TODO: as far as I can tell there's no such thing
    L.error({err:err},"chatbox --> error : " + err);
   },
   onGrantRequestPermission: function (acid, pid) {
    APILAYER.allowPermission(pid, 1);
   },
   onQueryGroups:function(groups) {
    $rootScope.$broadcast('wtg.interact.groups',{
     groups: groups.map(function(gi) {
      return {
       id: WTGTB.bytes2Number(gi.di256.d),
       name: WTGTB.bytes2String(gi.di257.d,0,gi.di257.l)
      };
     })
    });
   },
   onQueryConversationsQueuedOnGroup:function(groupID,sortorder,offset,limit,conversations) {
    var bc = {
     gid: WTGTB.bytes2Number(groupID),
     convinfo: conversations.map(function(c) {
      return {
       id: WTGTB.bytes2Number(c.di261.d),
       ts: U.time.from_interact_epoch( WTGTB.getLittleEndianInt32(c.di262.d,0) ),
       status: WTGTB.bytes2Number(c.di264.d)
      };
     })
    };
    if(sortorder!==undefined) bc.sort = WTGTB.bytes2Number(sortorder);
    if(offset!==undefined) bc.offset = offset;
    if(limit!==undefined) bc.limit = limit;
    $rootScope.$broadcast('wtg.interact.group.conversations',bc);
   },
   onQueryListofConversationItems:function(/*nconversations,lconversationItems*/){
   },
   onQueryListofConversationMemberList:function(conv,nMembers,lMemberItems) {
    if( nMembers!=lMemberItems.length )
     L.error({conv:conv,nmembers:nMembers,members:lMemberItems},"Now this is interesting, I was just wondering if this is a potential source of inconsistency");
    $rootScope.$broadcast('wtg.interact.conversation.members',{
     convid: WTGTB.bytes2Number(conv),
     members: lMemberItems.map(function(mi) {
      var rv = {
       acid: WTGTB.bytes2Number(mi.di1.d)
      };
      if(mi.di2) rv.dn = WTGTB.bytes2String(mi.di2.d,0,mi.di2.l);
      if(mi.di269) rv.nsessions = WTGTB.getLittleEndianInt16(mi.di269.d,0);
      return rv;
     })
    });
   },
   onConversationStatusChange:function(groupID, conv, status) {
    status=status[0];
    var change;
    switch(status) { // TODO: magical mystery tour
     case 1: change='add'; break;
     case 2: change='remove'; break;
     default: change='unknown'; break;
    }
    $rootScope.$broadcast('wtg.interact.group.conversation.change',{
     gid: WTGTB.bytes2Number(groupID),
     convid: WTGTB.bytes2Number(conv),
     status: status,
     change: change
    });
   },
   onCreateVirtualConnection:function(connectionID/*,accountID,sessionID,permissionCode*/) {
    APILAYER.acceptVirtualConnection(connectionID,1);
   },
   onReceivingFileInfoData:function(messageID,fileInfoID,filename,filepathname,filesize,timestamp,filetype) {
    L.trace(
     "messageID: "+messageID + " fileInfoID: "+fileInfoID +
     "filepathname: "+ filepathname+ " filesize: "+filesize+
     "timestamp: "+timestamp + "filetype: "+filetype);
    var mid = WTGTB.bytes2Number(messageID);
    var st = $rootScope.SecurityTests.find(function(x){return x.mid==mid});
    if(st) st.fid = WTGTB.bytes2Number(fileInfoID);
   },
   onReceiveFileData:function(imageData,fileInfoID) {
    if(!imageData) return;
    L.trace("total image data received (whatever it means)");
    var base64data = BASE64.fromByteArray(imageData);
    base64data = "data:image/jpg;base64,"+base64data;
    var thatfid = WTGTB.bytes2Number(fileInfoID)-1;
    var index = $rootScope.SecurityTests.findIndex(function(x){return x.fid==thatfid});
    if(index<0) return;
    var st = $rootScope.SecurityTests[index];
    var did = (st.tid==121)?'did':'didS'; // TODO:there should be no magic numbers
    did += st.did;
    if(!images[did]) images[did] = {};
    var fid = 'fid'+(WTGTB.bytes2Number(fileInfoID));
    images[did][fid] = [];
    // TODO: whatever the code below does, it does it wrong.
    for(did in images) {
     if(images[did][fid]) {
      images[did][fid] = base64data;
      break;
     }
    }
    $rootScope.remoteImages = images;
    if(st.did!=$rootScope.deviceID) {
     $rootScope.SecurityTests.splice(index,1);
     return; // to avoid image attachment for wrong device
    }
    // TODO: there should be no magic numbers
    $rootScope.$broadcast((st.tid==121)?"onUpdateImageGallery":"onUpdateScreenshotImageGallery",images,st.did);
    $rootScope.SecurityTests.splice(index,1); // XXX: this duplication in if and else looks suspicious
   },
   onvirtualConnetionStatusChange:function(connectionID,statuscode,permissionCode) {
    L.trace("connectionID:"+connectionID+"statuscode:"+statuscode+"channel:"+permissionCode);
    switch(+statuscode) {
     case INTERACT.D.virtual_connection.status.create:
      $rootScope.remoteConnection.id = connectionID;
      $rootScope.virtualConnection.cid = connectionID;
      break;
     case INTERACT.D.virtual_connection.status.accept:
      $rootScope.fetch_status();
      if(!$rootScope.isHidden("locatetest")) {
       if($("#mini-map-canvas").length) $rootScope.initialize_map('mini-map-canvas');
       $rootScope.checkAndRunLocationTest({}, true);
      }
      break;
     case INTERACT.D.virtual_connection.status.close:
      if(connectionID == $rootScope.virtualConnection.cid) $rootScope.virtualConnection = {};
      break;
     }
   },
   onRemoteData:function(vcdata) {
    if(!$rootScope.conStatus) {
     $timeout(
      function() {
       $rootScope.sendButtonKeyEvent('0xffc0');
      }, 2000);
    }
    $rootScope.$applyAsync(function() {
     $rootScope.conStatus = true;
     $rootScope.remoteConnection.connected = true;
    });
    var d = {};
    d.data = vcdata;
    novnc.onReceiveData(d);
   },
   onSpeedTestData:function(vcdata) {
    var str = WTGTB.bytes2String(vcdata,0,vcdata.length);
    if($rootScope.speedTestTimeout) $timeout.cancel($rootScope.speedTestTimeout);
    var o = JSON.parse(str);
    if($rootScope.virtualConnection.did==$rootScope.deviceID) {
    speed_test.process("speedtest",o);
     if(o.stt==$rootScope.speed_test_type.total_speed) {
      switch(o.t)
      {
       case 'dl':
        switch(o.s)
        {
         case 4:
         case 5:
           $rootScope.speedTestbtnDisable = false;
           break;
        }
       break;
       case 'ul':
       {
        switch(o.s)
        {
         case 3:
         case 4:
         case 5:
           $rootScope.speedTestbtnDisable = false;
           break;
        }
       }
       break;
      }
     }
    }
   },
   onCircleLiveData:function(vcdata) {
    /* TODO: it's still in vain, we don't even know what device the data is
       coming from… */
    var r = JSON.parse(WTGTB.bytes2String(vcdata,0,vcdata.length));
    $rootScope.$broadcast('wtg.interact.results-data',{r});
   },
   onTicketStatusChange:function(conID, convStatus, bundle) {
    $rootScope.$broadcast('wtg.interact.conversation.change',bundle);
   },
   onPingServer:function(pl) {
    $rootScope.$broadcast('wtg.interact.pong',{payload:pl});
    clearTimeout($rootScope.pingServerTimer);
   },
   onVCControlData:function(data) {
    var str = WTGTB.bytes2String(data,0,data.length);
    L.trace("onVCControlData: "+str);
    var o = JSON.parse(str);
    if(o&&o.flow) {
     switch(o.flow) {
      case INTERACT.D.virtual_connection.type.remote:
       if(o.e) {
        $rootScope.remote_error_message = o.e;
        $('#remote-fail-modal').modal();
        $rootScope.enableRemoteButton();
        return;
       }
       $rootScope.enableRemoteButton();
       $rootScope.remoteCID = $rootScope.virtualConnection.cid;
       if($rootScope.remoteConnection.did == $rootScope.deviceID) {
        var _encodings =[];
        var noVNC_encodeProtocol = PERSISTENCE.get("noVNC_encodeProtocol");
        if(noVNC_encodeProtocol) {
         _encodings = [
          ['COPYRECT',            0x01 ],
          ['TIGHT',               0x07 ],
          ['DesktopSize',         -223 ],
          ['Cursor',              -239 ],
          // Psuedo-encoding settings
          ['JPEG_quality_med',     -26 ],
          ['compress_hi',         -247 ],
          ['last_rect',           -224 ],
          ['xvp',                 -309 ],
          ['ExtendedDesktopSize', -308 ]];
         for (var i = 0; i < _encodings.length; i++) {
          if(_encodings[i][0] == "TIGHT") {
           if(noVNC_encodeProtocol == "tight") { _encodings[i][0]= 'TIGHT'; _encodings[i][1]= 0x07 }
           if(noVNC_encodeProtocol == "tight_png") { _encodings[i][0]= 'TIGHT_PNG'; _encodings[i][1]= (-260) }
           if(noVNC_encodeProtocol == "hextile") { _encodings[i][0]= 'HEXTILE'; _encodings[i][1]= 0x05 }
           if(noVNC_encodeProtocol == "raw") { L.trace("mani------raw protocol");_encodings[i][0]='RAW'; _encodings[i][1]= 0x00 }
           break;
          }
         }
        }
        var encryptValue=PERSISTENCE.get("noVNC_encrypt",$window.location.protocol=="https:");
        var true_colorValue=PERSISTENCE.get("noVNC_true_color",true);
        var cursorValue = PERSISTENCE.get("noVNC_cursor",true);
        var sharedValue = PERSISTENCE.get("noVNC_shared",true);
        var view_onlyValue = PERSISTENCE.get("noVNC_view_only",false);
        var scaleType = PERSISTENCE.get("noVNC_resize",'scale');
        novnc.init('noVNC_container','noVNC_canvas',scaleType,
         {
          encrypt:encryptValue,
          true_color:true_colorValue,
          cursor:cursorValue,
          shared:sharedValue,
          view_only:view_onlyValue,
          repeaterID: ''
         },
         _encodings,remoteCallback);
        novnc.connect();
        $rootScope.$applyAsync(function() {
         $rootScope.remoteConnection.cid = $rootScope.virtualConnection.cid;
        });
        APILAYER.sendData(+$rootScope.virtualConnection.cid, 'VNC'.split('').map(function(x){return x.charCodeAt(0)}));
       }
       break;
      default:
       L.trace("case not handled - onVCControlData -"+o);
     }
    }
   },

   onAdminResult: function on_admin_result(args) {
    $rootScope.$broadcast('wtg.interact.conversation.admin-result',args);
   }
  };

  function webRTCHandler(data) {
   switch(data.type) {
     case 'remote-stream':
      $("#localVideo").show();
      $("#remoteVideo").show();
      document.getElementById('remoteVideo').srcObject = data.s;
      document.getElementById('remoteVideo').play();
     break;
     case 'video-response':
      $rootScope.$broadcast('video-response', data);
     break;
     case 'media-change':
      $rootScope.$broadcast('wtg.wrtc.meida-change', data);
     break;
     case 'video-close':
      $rootScope.$broadcast('video-close', data);
     break;
     case 'video-request':
      $rootScope.showIncomingCallAlert(data.by,$rootScope.conversationID,data.did?data.did:$rootScope.deviceID);
     break;
     case 'call-interrupted':
      $rootScope.$broadcast('wtg.wrtc.call-interrupted', data);
     break;
   }
  }

  var EventHandler = {
   killme: {
    apilayer_callbacks: apilayer_callbacks
   },
   //Methods to support controllers having access to account/server information
   APILAYER: APILAYER,
   WTGTB:WTGTB,
   BASE64:BASE64,
   WRTC:WRTC,
   startRemote: function (aid, did) {
    $rootScope.remoteAID = aid;
    $rootScope.remoteDID = did;
    APILAYER.sendVCControlData($rootScope.virtualConnection.cid,'{"flow":'+INTERACT.D.virtual_connection.type.remote+',"action":"run"}');
   },
   startSpeedTest: function (/*aid, did*/) {
    var cap = $rootScope.speedtest_capabilities;
    var c = cap.version?cap:{stt:Object.keys(cap)};
    APILAYER.sendMessage({
     convid: +$rootScope.conversationID,
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg: `1|${TODO.test_id.speed_test}|0|${JSON.stringify(c)}`,
     devid: +$rootScope.deviceID
    });
    $timeout.cancel($rootScope.speedTestTimeout);
   },
   stopRemote: function () {
    novnc.disConnect();
    APILAYER.sendVCControlData($rootScope.virtualConnection.cid,'{"flow":'+INTERACT.D.virtual_connection.type.remote+',"action":"stop"}');
   },
   createRemoteVirtualConnection: function (aid, did) {
    L.warn({aid:aid,did:did},"WIP: creating remote virtual connection");
    APILAYER.createVirtualConnection({acid:aid,devid:did,pcode:INTERACT.D.xaction.channel.remote});
   },
   /* TODO: this function should probably not exist, so I'm not puting anything
    * about fixing it in the todo here… */
   getAccountInfo: function () {
    return { accountName: INTERACT.state.connection.acname };
   },
   startVCforLiveData: function (aid, did) {
    if($rootScope.virtualConnection) {
     if($rootScope.virtualConnection.did==did) return;
     APILAYER.closeVirtualConnection($rootScope.virtualConnection.cid);
    }
    $timeout(function() {
     $rootScope.virtualConnection = {};
     $rootScope.virtualConnection.acid = aid;
     $rootScope.virtualConnection.did = did;
     APILAYER.createVirtualConnection({acid:aid,devid:did,pcode:INTERACT.D.xaction.channel.remote});
    },2000);
   },
   stopLiveDataConnection: function (convid) {
    EventHandler.APILAYER.sendMessage({
     convid: convid,
     channelid: INTERACT.D.xaction.channel.diagreq,
     msg: INTERACT.D.xaction.payload.stop_status_flow,
     devid: $rootScope.deviceID
    });
    if($rootScope.virtualConnection) EventHandler.APILAYER.closeVirtualConnection($rootScope.virtualConnection.cid);
    $rootScope.virtualConnection={};
   },
   prepareDevices:function(d) {
    var r = d.filter(function(x){
      return ((x.type >= 2) && (x.man || x.model || x.identifier));
     }).map(function(x){
      x.date = WTGTB.get12HourTime(U.time.from_unix_epoch(x.ts), true);
      x.img = "images/phone1.jpeg";
      var model_info=(x.man?(x.man+" "+(x.model||"")):x.model)||"";
      x.name = ((x.name||"")+ (model_info?(" - "+model_info):"")) || x.identifier;
      return x;
     });
    // TODO: the below makes no sense, we should instead handle empty list on the
    // presentation level and not even present it as a dropdown.
    if(!r.length) r = [{"name": $rootScope.getString('str_not_found')}];
    return r;
   },
   send_call_request:function() {
    var selfid = INTERACT.get_myself().id;
    $rootScope.appendMessageToHistory({
     convid: $rootScope.conversationID,
     acid: selfid,
     msg: $rootScope.strings.str_support_requested_call,
     msgtime: new Date(),
     channelid: 10 // TODO: magic
    });
    APILAYER.sendMessage({
     convid: +$rootScope.conversationID,
     channelid: INTERACT.D.xaction.channel.videochat,
     msg: JSON.stringify({type:'video-request',by:selfid,to:$rootScope.accountID}),
     devid: +$rootScope.deviceID,
     validity: 5000
    });
   },
   closeWRTC:function() {
     WRTC.closeVideo($rootScope.accountID);
   }
  };
  INTERACT.killme.inject_EventHandler(EventHandler);
  return EventHandler;
 }]);
/* vim:set ts=8 sw=1 expandtab: */
